// extracted by mini-css-extract-plugin
export default {"formgroup":"userForm_formgroup__4f86+"};